import { AuthHelper } from 'helpers/auth-helper';
import axios, { AxiosRequestConfig, AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios';
import { ValidateResponseError } from 'utils/misc';
import { toast } from 'react-toastify';
import { CustomToast } from "components";
import { useDispatch } from 'react-redux';
import { logOut } from 'store/auth';


export const initInterceptors = () => {
    console.log('init interceptor')
    axios.interceptors.request.use(
        async (config) => {
            const result = AuthHelper.getCredentials('access_token');
            const token = result ? result : null;
            // const deviceJson = (JSON.stringify(getDeviceInfo())).replace("’", "");
            // console.log("intercepting: ", token, result)
            // config.headers = { ...config.headers } as Partial<AxiosRequestHeaders>;
            config.headers = { ...config.headers } as AxiosRequestHeaders;
            // console.log(process)
            if (token) {
                config.headers['Authorization'] = `${token}`
            }

            // console.log(config.headers);

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        (response) => {

            return response;
        },
        async (error) => {
            const result = AuthHelper.getCredentials('access_token');
            const token = result ? result : null;
            console.log(error, result)
            if (error.response.status == 401) {
                // const dispatch = useDispatch();
                // dispatch(logOut())
                AuthHelper.clearCredentials();

            }
            if (ValidateResponseError(error.response, token)) {
                AuthHelper.clearCredentials();
            }

            return Promise.reject(error);
        }
    );
}